import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { getRouter } from 'router';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';
import { shareFriend, sharePyq } from 'utils/wxShare';
import Stores from 'config/Stores';
import Config from 'config/Config';
import { inject, observer } from 'mobx-react';
import { getAuthRouteList } from 'utils/authUtil';
import { initThrottledJump } from 'utils/throttledJump';

const CDN_BASE = Config.CDN_BASE || '';

const DefaultQueryKey = '_k';
const KeyPrefix = '@@History/';

function createKey() {
  return Math.random().toString(36).substr(2, 6);
}
@inject('AppMod')
@withRouter
@observer
class LayoutView extends Component {
  constructor(props) {
    super(props);
    // 设置全局router对象，用于在Mod中的跳转
    window.app.router = this.props.history;
    this.state = {};
    this.props.AppMod.changeState('isCardCode', { cardCode: Util.getQueryString('cardCode') });
    if (Util.getQueryString('bindCardCode')) {
      this.props.AppMod.changeState('bindCardCode', {
        cardCode: Util.getQueryString('bindCardCode')
      });
      Util.setLocalCache('bindCardCode', Util.getQueryString('bindCardCode'));
    } else if (Util.getLocalCache('bindCardCode')) {
      this.props.AppMod.changeState('bindCardCode', {
        cardCode: Util.getLocalCache('bindCardCode')
      });
      Util.setLocalCache('bindCardCode', Util.getLocalCache('bindCardCode'));
    }

    if (Util.getQueryString('shareCardCode')) {
      this.props.AppMod.changeState('bindCardCode', {
        cardCode: Util.getQueryString('shareCardCode')
      });
      Util.setLocalCache('bindCardCode', Util.getQueryString('shareCardCode'));
    }

    initThrottledJump();
  }

  componentWillMount() {
    const isLY = sessionStorage.getItem('systemCode') == 'LY';
    // 重写这两个方法，以监控路由跳转次数
    window.app.routerGoTo = (path) => {
      if (isLY && typeof path == 'string') {
        if (path.indexOf('?') != -1) {
          path += '&systemCode=LY';
        } else {
          path += '?systemCode=LY';
        }
      }
      const { cardCode } = Stores.AppMod.userInfo || {};
      if (cardCode) {
        if (typeof path == 'string') {
          if (path.indexOf('?') != -1) {
            path = `${path}&bindCardCode=${cardCode}`;
          } else {
            path = `${path}?bindCardCode=${cardCode}`;
          }
        }
      }

      this.handleRouterState(path);
      // this.props.appMod.addHistory();
      window.app.router.push(path);
      // 初始化微信配置（分享）
      this.initShare();
    };
    window.app.routerRedirect = (path) => {
      if (isLY && typeof path == 'string') {
        if (path.indexOf('?') != -1) {
          path += '&systemCode=LY';
        } else {
          path += '?systemCode=LY';
        }
      }
      const { cardCode } = Stores.AppMod.userInfo || {};
      if (cardCode) {
        if (typeof path == 'string') {
          if (path.indexOf('?') != -1) {
            path = `${path}&bindCardCode=${cardCode}`;
          } else {
            path = `${path}?bindCardCode=${cardCode}`;
          }
        }
      }
      this.handleRouterState(path);
      window.app.router.replace(path);
    };
    window.app.router.goBack = (count) => {
      // this.props.appMod.minusHistory();
      const routerCount = sessionStorage.getItem('routerCount');
      if (count) {
        this.changeRouterCount(parseInt(count) + 1);
      }
      if (!routerCount || routerCount <= 0) {
        window.app.routerGoTo('/');
      } else {
        window.app.router.go(count || -1);
      }
    };
  }

  componentDidMount() {
    // 想要监听资源加载失败，必须用addEventListener且开启捕获模式
    window.addEventListener(
      'error',
      ({ target }) => {
        if (target.tagName === 'IMG') {
          this.setDefaultImg(target);
        }
      },
      true
    );
    this.unlisten = this.props.history.listen(this.onRouterLitsen);
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  /**
   * 初始化微信分享配置
   */
  initShare = () => {
    const isWeChat = Util.isWeiXin();
    const { cardCode } = Stores.AppMod.userInfo || {};

    if (isWeChat) {
      initConfig(true); // 初始化微信配置
      const title = `有享云商`;
      const desc = '三生（中国）为您提供专业优质服务';
      const imgUrl = `${window.location.origin}/favicon.ico`;
      const link = `${window.location.origin}$cardCode=${cardCode}`;
      // 分享给朋友
      shareFriend({
        title,
        desc,
        imgUrl,
        link
      });
      // 分享到朋友圈
      sharePyq({
        title,
        imgUrl,
        link
      });
    }
  };

  /**
   * 比较图片尺寸，设置默认图
   */
  setDefaultImg(target) {
    let src = `/assets/imgs/default/default2.png`;
    if (!target.alt) {
      // alt属性会导致宽高不准确
      const { width, height } = target;
      const list = ['1x2', '2x1', '3x4', '4x3', '9x16', '16x9'];

      let minDiff = Math.abs(width / height - 1);
      for (const item of list) {
        const temArr = item.split('x');
        const diff = Math.abs(width / height - temArr[0] / temArr[1]);
        if (diff < minDiff) {
          src = `/assets/imgs/default/default${item}.png`;
          minDiff = diff;
        }
      }
    }

    target.src = `${CDN_BASE}${src}`;
  }

  onRouterLitsen = (location, action) => {
    const { pathname, search } = location;
    if (action == 'POP') this.changeRouterCount(-1);
    if (action == 'PUSH') this.changeRouterCount(1);
  };

  /**
   * sessionStorage 持久化路由次数
   * @param {Number} count - 增减路由跳转次数
   */
  changeRouterCount(count) {
    let routerCount = sessionStorage.getItem('routerCount');
    let newCount = +(routerCount || 0) + parseInt(count);
    sessionStorage.setItem('routerCount', newCount > 0 ? newCount : 0);
  }

  /**

* 处理state参数，拼接_k=到url后，存储state到sessionStorage，实现隐式传参

*/

  handleRouterState(path) {
    if (typeof path == 'object' && path.state) {
      let oldSearch = '';
      if (path.search) {
        oldSearch = `${path.search}&`;
      }
      try {
        if (path.pathname && path.pathname.includes('?')) {
          const [pathname, urlSearch] = path.pathname.split('?');
          path.pathname = pathname; // 提取纯路径
          let searchPrefix = `${oldSearch ? '' : '?'}`;
          // 合并search参数，处理各种情况
          if (path.search) {
            // 确保search格式正确
            const existingSearch = path.search.startsWith('?')
              ? path.search.substring(1)
              : path.search;

            oldSearch = `${searchPrefix}${urlSearch}&${existingSearch}&`; // 合并URL参数和已有search参数
          } else {
            oldSearch = `${searchPrefix}${urlSearch}&`; // 只有URL参数的情况
          }
        }
      } catch (e) {
        console.log('path解析异常', e);
      }
      const key = createKey();
      path.search = `${oldSearch + DefaultQueryKey}=${key}`;
      sessionStorage.setItem(KeyPrefix + key, JSON.stringify(path.state));
      if (path.pathname && path.pathname.indexOf('/login') > -1) {
        // 和全局loginGoback有重叠，因场景太多容易混淆，故此处单独命名处理
        Util.setLocalCache('loginH5Goback', window.location.href);
      }
    }
  }

  render() {
    return <div style={{ height: '100%' }}>{getRouter()}</div>;
  }
}

export default LayoutView;



// WEBPACK FOOTER //
// ./src/widget/Layout/LayoutView.js